module.exports = __webpack_public_path__ + "static/img/zlogo.9a2181a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/zlogo.png
// module id = KFch
// module chunks = 36